// src/components/sections/HomeAboutSnippet.jsx
import React from 'react'
import { motion as Motion } from 'framer-motion'
// import FrameGlobe from '../../assets/Frame 102.svg'
// import Ellipse from '../../assets/Ellipse 6.png'
import './HomeAboutSnippet.scss' // copy of About.scss adapted path

export default function HomeAboutSnippet({ sectionData }) {
    if (!sectionData) {
        return (
            <section className="bg-black">
                <div className="container-custom section-padding">
                    <div className="max-w-4xl mx-auto text-center animate-pulse">
                        <div className="space-y-4">
                            <div className="h-4 bg-black-200 rounded w-full"></div>
                            <div className="h-4 bg-black-200 rounded w-5/6 mx-auto"></div>
                            <div className="h-4 bg-black-200 rounded w-4/6 mx-auto"></div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    const { imageUrl, para1, para2 } = sectionData

    return (
        <div className="about-section-parent-home">
            <div className="about-section">
                <div className="about-section-title">
                    <Motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        {imageUrl && (
                            <img src={imageUrl} className="home-about-img" alt="" />
                        )}
                        {/* You can split para1 with spans if you want highlights, or just show it: */}
                        {/* {para1} */}
                        Logiqlink Technologies <span className='about-highlight'>is a technology consulting and engineering company,</span> focusing on IoT product development, digital experience design, <span className='about-highlight'>and</span> digital marketing strategy.
                    </Motion.h2>

                    {para2 && (
                        <Motion.h2
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8, delay: 0.3 }}
                        >
                            {/* {para2} */}
                            <span className='about-highlight'>We provide a wide range of</span> engineering services <span className='about-highlight'>and</span> industry expertise <span className='about-highlight'>to help</span> clients create new products and implement digital transformations <span className='about-highlight'>in their existing systems.</span>
                        </Motion.h2>
                    )}
                </div>
            </div>
            {/* <img src={FrameGlobe} className="about-bottom-img" alt="" />
            <img src={Ellipse} className="about-ellipse-img" alt="" /> */}
        </div>
    )
}
